module.exports = __webpack_public_path__ + "mo/img/swiper_bg07.7b823190.png";